import { render, staticRenderFns } from "./CheckoutApplyCredits.vue?vue&type=template&id=c8c0db18&"
import script from "./CheckoutApplyCredits.js?vue&type=script&lang=js&"
export * from "./CheckoutApplyCredits.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CheckoutApplyCredits.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fbase%2Fcomponents%2Fcart%2FCheckoutApplyCredits%2FCheckoutApplyCredits.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports